import React from 'react';
import '../styling/Extensions.scss';

const Extensions = () => (
  <div className="extensions">
    Nos Extensions
  </div>
);

export default Extensions;
